<template>
    <div>
        <app-header :closeable="true" :title="'Room is full'"></app-header>

        <section class="container">
            <div class="intro-content pt--40 pb--40">
                <img src="/img/logo-title.png" alt="" class="intro-content__logo"/>
            </div>

            <div class="mb--lg">
                <div class="text--center text--lg weight--bold mb--10">
                    The room is full, please try to connect to another room.
                </div>

                <button-link :to="'/find-room'" class="btn btn--block btn--white btn--left-icon mb--md">
                    <img src="/img/icons/find.svg" alt=""/>Find room
                </button-link>
            </div>
        </section>
    </div>
</template>

<script>
import AppHeader from "../../partial/AppHeader";
import ButtonLink from "../../partial/ButtonLink";

export default {
    components: {AppHeader, ButtonLink}
}
</script>